import { render, staticRenderFns } from "./popupList.vue?vue&type=template&id=f8f00bce&"
import script from "./popupList.vue?vue&type=script&lang=js&"
export * from "./popupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports